import { Reveal } from './Reveal';
import { dogs } from '../content/wedding';

/**
 * Rowan and Winston, a breath between the countdown and the story.
 *
 * The two files share a height and are bottom-aligned inside it, so the
 * relative size of the dogs — Rowan is the taller — and the ground line they
 * stand on both come out of the drawings themselves. A single height in CSS
 * is all the sizing this needs.
 */

/** Intrinsic size of the derivatives — reserved up front so the closing band
 *  does not jump when they load. Keep in step with `scripts/dogs.mjs`. */
const SIZE: Record<(typeof dogs)[number]['name'], { w: number; h: number }> = {
  rowan: { w: 247, h: 528 },
  winston: { w: 297, h: 528 },
};

export function Dogs() {
  return (
    <Reveal class="dogs" delay={260}>
      {dogs.map((dog) => (
        <img
          key={dog.name}
          class="dogs__dog"
          src={`/dogs/${dog.name}.png`}
          alt={dog.alt}
          width={SIZE[dog.name].w}
          height={SIZE[dog.name].h}
          loading="lazy"
          decoding="async"
        />
      ))}
    </Reveal>
  );
}
